export default "__VITE_ASSET__DrfC7lF1__"